import { FormHelperText, Stack, Typography } from '@mui/material'
import { useTexts } from '../hooks/useTexts'
import { form } from './formState'

export function CheckList() {
  const texts = useTexts()

  const {
    meta: { status },
  } = form.useFormMeta()

  return (
    <Stack spacing={3} mt={3}>
      <Typography variant="body2">{texts.form.title}</Typography>
      <Stack spacing={1}>
        <form.Checkbox
          label={texts.form.c1}
          validateOn="blur change"
          name="c1"
          testId="c1"
          errorVisibility="none"
        />
        <form.Checkbox
          label={texts.form.c2}
          validateOn="blur change"
          name="c2"
          testId="c2"
          errorVisibility="none"
        />
        <form.Checkbox
          label={texts.form.c3}
          validateOn="blur change"
          name="c3"
          testId="c3"
          errorVisibility="none"
        />
        <form.Checkbox
          label={texts.form.c4}
          validateOn="blur change"
          name="c4"
          testId="c4"
          errorVisibility="none"
        />
      </Stack>
      {status === 'invalid' && (
        <FormHelperText error>{texts.validation.notAllChecked}</FormHelperText>
      )}
    </Stack>
  )
}
